export class ContactUsForm {
  title: string;
  description: string;
  email: string;

  constructor(title: string, description: string, email: string) {
    this.title = title;
    this.description = description;
    this.email = email;
  }
}
